<template>
<!-- 입점 신청 페이지 -->
<div>
<div>
<Loading :active="isLoading" :can-cancel="false"></Loading>

<div v-if="isLoading" class="loading-message">
  <p>입점 신청 접수 중입니다.</p>
  <p>잠시만 기다려 주세요.</p>
</div>
</div>
<v-container pa-0 fluid>
<div class="insert-title">간편 입점 신청 정보 입력</div>
<div class="insert-border"></div>
<div class="insert-content-all">
  <div class="insert-content">
    <div class="insert-content-left">
      입점사유<span style="color: #01caff; font-size: 14px">(필수)</span>
    </div>
    <div class="insert-content insert-content-other">
      <div class="insert-content-num-input insert-content-radio-button">
        <v-radio-group class="radio-buttons-row" row v-model="joinReason">
          <v-radio label="신규" value="1" @change="joinReason = '1'"></v-radio>
          <v-radio label="해지 후 재입점" value="2" @change="joinReason = '2'"></v-radio>
          <v-radio label="양도양수" value="3" @change="joinReason = '3'"></v-radio>
          <v-radio label="명의변경" value="4" @change="joinReason = '4'"></v-radio>
        </v-radio-group>
      </div>
    </div>

    <div class="insert-content-left">
      사업자등록번호<span style="color: #01caff; font-size: 14px">(필수)</span>
    </div>
    <div class="insert-content-num-input insert-content-text-field">
      <v-text-field placeholder="000" outlined hide-details maxLength="3" color="#01c9ff" dense
        v-model="shop_reg_no1"></v-text-field>
    </div>
    <div class="insert-content-hyphen">-</div>
    <div class="insert-content-num-input insert-content-text-field">
      <v-text-field placeholder="00" outlined hide-details maxLength="2" color="#01c9ff" dense
        v-model="shop_reg_no2"></v-text-field>
    </div>
    <div class="insert-content-hyphen">-</div>
    <div class="insert-content-num-input insert-content-text-field">
      <v-text-field placeholder="00000" outlined hide-details maxLength="5" color="#01c9ff" dense
        v-model="shop_reg_no3"></v-text-field>
    </div>
    <div class="insert-btn insert-btn-duplicate" @click="goDupCheck">
      중복 조회
    </div>
  </div>
  <div class="insert-content insert-content-warn" v-if="checkedDuplicate || isDuplicated || isBisNumErr">
    <div class="insert-content-left-warn insert-content-left-space"></div>
    <div class="insert-content-warn-bottom-space">
      <span v-if="checkedDuplicate"> 입점 신청 가능합니다. </span>
      <span v-if="isDuplicated" style="color: red">
        이미 등록되어있는 가맹점입니다. 1661-3773으로 문의해주세요.
      </span>
      <span v-if="isBisNumErr" style="color: red">
        유효한 사업자등록번호가 아닙니다. 확인해 주세요.
      </span>
    </div>
  </div>
  <div class="insert-content insert-content-other">
    <div class="insert-content-left">
      매장 명<span style="color: #01caff; font-size: 14px">(필수)</span>
    </div>
    <div class="insert-content-store-name-input insert-content-text-field">
      <v-text-field placeholder="매장명" outlined hide-details color="#01c9ff" dense
      maxlength="30" counter="30" v-model="shop_name"></v-text-field>
    </div>
  </div>
  <div class="insert-content insert-content-warn">
    <div class="insert-content-left-warn insert-content-left-space"></div>
    <div class="insert-content-warn-bottom-space" style="color: red">
      ※ 타 플랫폼에서 운영중인 매장명 혹은 대구로에서 운영하실 매장명을 기입해주세요.
    </div>
  </div>

  <div class="insert-content insert-content-other">
    <div class="insert-content-left">
      사업주 명<span style="color: #01caff; font-size: 14px">(필수)</span>
    </div>
    <div class="insert-content-store-name-input insert-content-text-field">
      <v-text-field placeholder="사업주명" outlined hide-details color="#01c9ff" dense
        v-model="shop_ceo"></v-text-field>
    </div>
  </div>
  <div class="insert-content insert-content-other">
    <div class="insert-content-left">
      사업주 휴대전화번호<span style="color: #01caff; font-size: 14px">(필수)</span>
    </div>
    <div class="insert-content-num-input insert-content-text-field">
      <v-select outlined dense :items="phone1" color="#01c9ff" v-model="ceo_phone1"></v-select>
    </div>
    <div class="insert-content-hyphen">-</div>
    <div class="insert-content-num-input insert-content-text-field">
      <v-text-field placeholder="1234" outlined hide-details color="#01c9ff" maxLength="4" dense
        v-model="ceo_phone2" @keyup="ceo_phone2 = $event.target.value"></v-text-field>
    </div>
    <div class="insert-content-hyphen">-</div>
    <div class="insert-content-num-input insert-content-text-field">
      <v-text-field placeholder="5678" outlined hide-details color="#01c9ff" maxLength="4" dense
        v-model="ceo_phone3" @keyup="ceo_phone3 = $event.target.value"></v-text-field>
    </div>
  </div>
  <div class="insert-content insert-content-other">
    <div class="insert-content-left">
      부재시 연락가능번호<span style="color: black; font-size: 14px">(선택)</span>
    </div>
    <div class="insert-content-num-input insert-content-text-field">
      <v-select outlined dense :items="phone1" color="#01c9ff" v-model="ceo_sub_phone1"></v-select>
    </div>
    <div class="insert-content-hyphen">-</div>
    <div class="insert-content-num-input insert-content-text-field">
      <v-text-field placeholder="1234" outlined hide-details color="#01c9ff" maxLength="4" dense
        v-model="ceo_sub_phone2" @keyup="ceo_sub_phone2 = $event.target.value"></v-text-field>
    </div>
    <div class="insert-content-hyphen">-</div>
    <div class="insert-content-num-input insert-content-text-field">
      <v-text-field placeholder="5678" outlined hide-details color="#01c9ff" maxLength="4" dense
        v-model="ceo_sub_phone3" @keyup="ceo_sub_phone3 = $event.target.value"></v-text-field>
    </div>
  </div>
  <div class="insert-content insert-content-other">
    <div class="insert-content-left">
      매장 주소<span style="color: #01caff; font-size: 14px">(필수)</span>
    </div>
    <div class="insert-content-store-addr-input insert-content-text-field">
      <v-text-field placeholder="매장 주소를 검색해 주세요" outlined hide-details color="#01c9ff" dense
        v-model="shop_address" @click="dialog = true" readonly></v-text-field>
    </div>
    <div class="insert-btn insert-addr-btn" @click="openPostcode">
      주소 검색
    </div>
  </div>
  <div class="insert-content">
    <div class="insert-content-left insert-content-left-space"></div>
    <div class="insert-content-store-addr-input insert-content-store-addr-input-2 insert-content-text-field">
      <v-text-field placeholder="상세주소 입력" outlined hide-details color="#01c9ff" dense
        v-model="shop_address_detail"></v-text-field>
    </div>
  </div>
  <div class="insert-content insert-content-other">
    <div class="insert-content-left">
      매장 전화번호<span style="color: #01caff; font-size: 14px">(필수)</span>
    </div>
    <div class="insert-content-num-input insert-content-text-field">
      <v-select outlined dense :items="tel1" color="#01c9ff" v-model="shop_tel1"></v-select>
    </div>
    <div class="insert-content-hyphen">-</div>
    <div class="insert-content-num-input insert-content-text-field">
      <v-text-field placeholder="1234" outlined hide-details color="#01c9ff" maxLength="4" dense
        v-model="shop_tel2" @keyup="shop_tel2 = $event.target.value"></v-text-field>
    </div>
    <div class="insert-content-hyphen">-</div>
    <div class="insert-content-num-input insert-content-text-field">
      <v-text-field placeholder="5678" outlined hide-details color="#01c9ff" maxLength="4" dense
        v-model="shop_tel3" @keyup="shop_tel3 = $event.target.value"></v-text-field>
    </div>
  </div>
  <div class="insert-content insert-content-other">
    <div class="insert-content-left">
      가맹점 로고이미지<span style="color: black; font-size: 14px">
        (선택)</span>
    </div>
    <div class="insert-content-store-addr-input insert-content-text-field">
          <v-checkbox class="v-checkbox1" v-model="checkLogoCreate" false-value="0" true-value="1" color="#01c9ff"
        label="제작 요청"></v-checkbox>
    </div>
  </div>
  <div class="insert-content insert-content-warn">
    <div class="insert-content-left-warn insert-content-left-space"></div>
    <div class="insert-content-warn-bottom-space" style="color: red">
      ※ 로고이미지가 없으실 경우 대구로에서 로고이미지를 자체제작 해드립니다.(하단예시)
    </div>
  </div>
  <div class="insert-content insert-content-warn" style="margin-bottom: 20px;">
    <div class="insert-content-left-warn insert-content-left-space"></div>
      <v-img :src="shopLogoSrc" class="insert-store-logo-img"></v-img>
  </div>



  

  <!-- <div class="insert-content insert-content-other">
    <div class="insert-content-left">
      업종 카테고리<span style="color: #01caff">*</span>
    </div>
    <div class="insert-content-num-input insert-content-select-list">
      <v-select
        outlined
        label="필수"
        item-text="name"
        item-value="code"
        :items="category"
        color="#01c9ff"
        v-model="shop_item1"
      ></v-select>
    </div>
    <div class="insert-content-space"></div>
    <div
      class="insert-content-num-input insert-content-select-list insert-content-select-list-2"
    >
      <v-select
        outlined
        label="선택"
        item-value="code"
        item-text="name"
        :items="category"
        color="#01c9ff"
        v-model="shop_item2"
      ></v-select>
    </div>
    <div class="insert-content-space"></div>
    <div
      class="insert-content-num-input insert-content-select-list insert-content-select-list-2"
    >
      <v-select
        outlined
        label="선택"
        item-value="code"
        item-text="name"
        :items="category"
        color="#01c9ff"
        v-model="shop_item3"
      ></v-select>
    </div>
  </div>
  <div class="insert-content insert-content-spec insert-content-warn">
    <div class="insert-content-left insert-content-left-space"></div>
    <div>※ 업종 카테고리는 최대 3개까지 선택 가능합니다.</div>
  </div> -->
  <!--        <div class="insert-content insert-content-other">
    <div class="insert-content-left insert-tit">
      예약<br>업종 카테고리<span style="color: #01caff">*</span>
    </div>
    <div class="insert-content-num-input insert-content-select-list">
      <v-select
          outlined
          label="필수"
          item-text="name"
          item-value="code"
          :items="category"
          color="#01c9ff"
          v-model="shop_item1"
      ></v-select>
    </div>
    <div class="insert-content-space"></div>
    <div
        class="
        insert-content-num-input
        insert-content-select-list
        insert-content-select-list-2
      "
    >
      <v-select
          outlined
          label="선택"
          item-value="code"
          item-text="name"
          :items="category"
          color="#01c9ff"
          v-model="shop_item2"
      ></v-select>
    </div>
  </div>
  <div class="insert-content insert-content-spec insert-content-warn">
    <div class="insert-content-left insert-content-left-space"></div>
    <div>※ 예약 업종 카테고리는 최대 2개까지 선택 가능합니다.</div>
  </div>
  <div class="insert-content insert-content-other">
    <div class="insert-content-left insert-tit">
      배달/포장<br>업종 카테고리<span style="color: #01caff">*</span>
    </div>
    <div class="insert-content-num-input insert-content-select-list">
      <v-select
          outlined
          label="필수"
          item-text="name"
          item-value="code"
          :items="category"
          color="#01c9ff"
          v-model="shop_item1"
      ></v-select>
    </div>
    <div class="insert-content-space"></div>
    <div
        class="
        insert-content-num-input
        insert-content-select-list
        insert-content-select-list-2
      "
    >
      <v-select
          outlined
          label="선택"
          item-value="code"
          item-text="name"
          :items="category"
          color="#01c9ff"
          v-model="shop_item2"
      ></v-select>
    </div>
    <div class="insert-content-space"></div>
    <div
        class="
        insert-content-num-input
        insert-content-select-list
        insert-content-select-list-2
      "
    >
      <v-select
          outlined
          label="선택"
          item-value="code"
          item-text="name"
          :items="category"
          color="#01c9ff"
          v-model="shop_item3"
      ></v-select>
    </div>
  </div>
  <div class="insert-content insert-content-spec insert-content-warn">
    <div class="insert-content-left insert-content-left-space"></div>
    <div>※ 배달/포장 업종 카테고리는 최대 3개까지 선택 가능합니다.</div>
  </div>-->
  <div class="insert-content insert-content-other">
    <div class="insert-content-left">
      이메일 주소<span style="color: #01caff; font-size: 14px">(필수)</span>
    </div>
    <div class="insert-content-num-input insert-content-email-input insert-content-text-field">
      <v-text-field outlined hide-details color="#01c9ff" dense v-model="email_id"></v-text-field>
    </div>
    <div class="insert-content-space2">@</div>
    <div class="insert-content-num-input insert-content-email-input insert-content-text-field"
      :class="{ none: display == true }">
      <v-text-field outlined color="#01c9ff" v-model="email_address" dense :readonly="disabled"
        style="font-size: 15px"></v-text-field>
    </div>
    <div class="insert-content-space" :class="{ none: display == true }"></div>
    <div class="insert-content-num-input insert-content-email-sel insert-content-text-field">
      <v-select outlined dense :items="email_category" color="#01c9ff" v-model="email_address_sel"
        style="font-size: 15px"></v-select>
    </div>
  </div>
  <div class="insert-content insert-content-other clearfix">
    <div class="insert-content-left">
      첨부파일<span style="color: #01caff; font-size: 14px">(필수)</span>
    </div>
    <!--          <div
        class="insert-content-store-addr-input insert-content-store-img-input">
      <v-file-input
          label="사업자등록증"
          outlined
          hide-details
          accept="image/*"
          color="#01c9ff"
          ref="shop_file_no1"
          @change="handleFileUpload_no1"
      ></v-file-input>
    </div>-->
    <div class="insert-content-file-input">
      <input type="file" id="shop_file_no1" ref="shop_file_no1" @change="handleFileUpload_no1" accept="image/*" />
      <p class="input-text">{{ file_name_no1 }}</p>
      <span class="input-label">사업자등록증</span>
    </div>
    <label class="insert-btn insert-file-btn" for="shop_file_no1">파일 찾기</label>
  </div>
  <div class="insert-content insert-content clearfix">
    <div class="insert-content-left insert-content-left-space"></div>
    <!--          <v-file-input
        label="영업신고증"
        outlined
        hide-details
        accept="image/*"
        color="#01c9ff"
        ref="shop_file_no2"
        @change="handleFileUpload_no2"
    ></v-file-input>-->
    <div class="insert-content-file-input">
      <input type="file" id="shop_file_no2" class="insert-content-file-input" ref="shop_file_no2"
        @change="handleFileUpload_no2" accept="image/*" />
      <p class="input-text">{{ file_name_no2 }}</p>
      <span class="input-label">영업신고증</span>
    </div>
    <label class="insert-btn insert-file-btn" for="shop_file_no2">파일 찾기</label>
  </div>
  <div class="insert-content insert-content clearfix">
    <div class="insert-content-left insert-content-left-space"></div>
    <!--            <v-file-input
          label="통장사본"
          outlined
          hide-details
          accept="image/*"
          color="#01c9ff"
          ref="shop_file_no3"
          @change="handleFileUpload_no3"
      ></v-file-input>-->
    <div class="insert-content-file-input">
      <input type="file" id="shop_file_no3" class="insert-content-file-input" ref="shop_file_no3"
        @change="handleFileUpload_no3" accept="image/*" />
      <p class="input-text">{{ file_name_no3 }}</p>
      <span class="input-label">통장사본</span>
    </div>
    <label class="insert-btn insert-file-btn" for="shop_file_no3">파일 찾기</label>
  </div>
  <div class="insert-content insert-content-warn">
    <div class="insert-content-left-warn insert-content-left-space"></div>
    <div class="insert-content-warn-bottom-space" style="color: red">
    ※ 사업자등록증 내 대표자명과 동일한 통장사본을 등록해주세요. (타인계좌 등록불가/공동사업자 명의 통장사본 등록 가능)<br>
    </div>
  </div>

  <!--
  <div class="insert-content">
    <div class="insert-content insert-content insert-content-other">
    </div>
    <div class="insert-content-left">
      정산 계좌<span style="color: #01c9ff; font-size: 14px">(필수)</span>
    </div>
    <div class="insert-content-num-input insert-content-text-field">
      <v-select placeholder="은행 선택" outlined dense :items="banks" color="#01c9ff" v-model="bank_name"></v-select>
    </div>

    <div class="insert-content-num-input insert-content-text-field" style="margin-left:14px; margin-right: 14px;">

      <v-text-field placeholder="계좌번호" outlined hide-details color="#01c9ff" dense v-model="bank_account_num"
        maxLength="15" @input.native="forceNumber"></v-text-field>
    </div>

    <div class="insert-content-num-input insert-content-text-field">

      <v-text-field placeholder="예금주" outlined hide-details color="#01c9ff" maxLength="4" dense
        v-model="bank_account_name" @keyup="bank_account_name = $event.target.value"></v-text-field>
    </div>

    <div class="insert-btn insert-btn-duplicate" @click="bankCheck">
      확인
    </div>
  </div>
  -->

  <div class="insert-content insert-content-warn" v-if="isCheckBank">
    <div class="insert-content-left-warn insert-content-left-space"></div>
    <div class="insert-content-warn-bottom-space">
      <span v-if="isCheckBank" style="color: #448aff;">
        사용 가능한 계좌입니다.
      </span>
    </div>
  </div>
  <div class="insert-content">
    <div class="insert-content insert-content-other">
      <div class="insert-content-left">
        타 플랫폼 사용여부<span style="color: #01caff; font-size: 14px">(필수)</span>
      </div>
      <div class="insert-content">
        <span class="insert-platform-content">현재 다른 배달앱(배달의 민족, 요기요, 쿠팡 등)을 사용
          중이신가요?</span>
      </div>
    </div>
    <div class="insert-content insert-content-warn">
      <div class="insert-content-left-warn insert-content-left-space"></div>
      <div class="insert-content-num-input insert-content-radio-button">
        <v-radio-group class="radio-buttons-row" row v-model="otherplatform">
          <v-radio label="예" value="1" @change="otherplatform = '1'"></v-radio>
          <v-radio label="아니오" value="0" @change="otherplatform = '0'"></v-radio>
        </v-radio-group>
      </div>
    </div>
    <div class="insert-content insert-content-other">
      <div class="insert-content-left">
        서비스 형태<span style="color: #01caff; font-size: 14px">
          (필수)</span>
      </div>
      <div class="insert-content-num-input insert-content-radio-button">
        <v-radio-group class="radio-buttons-row" row v-model="serviceType">
          <v-radio label="배달/포장" value="0" @change="serviceType = '0'"></v-radio>
          <v-radio label="배달" value="1" @change="serviceType = '1'"></v-radio>
          <v-radio label="포장" value="2" @change="serviceType = '2'"></v-radio>
        </v-radio-group>
      </div>


      <div class="insert-content-num-input insert-content-check-input2 checkbox-display" style="display: none">
        <v-checkbox class="v-checkbox1" v-model="checkreservation" false-value="0" true-value="9" color="#01c9ff"
          label="예약"></v-checkbox>
      </div>
    </div>
    <div class="insert-content insert-content-other">
      <div class="insert-content-left1">
        배달사 정보<span style="color: black; font-size: 14px">(선택)</span>
      </div>
      <div class="insert-content">
        <span class="insert-platform-content">현재 이용 중인 배달 대행사를 선택 해 주세요.</span>
      </div>
              <div class="insert-content insert-content-warn">
    <div class="insert-content-left-warn insert-content-left-space"></div>
    <div class="insert-content-warn-bottom-space" style="color: red">
      ※ 배달대행사 미계약 혹은 직접배달 불가능 시 대구로 배달 영업이 불가능합니다.
    </div>
  </div>

    </div>
    <div class="insert-content insert-content-other">
      <div class="insert-content-left2"></div>
      <div class="insert-content-num-input insert-content-check-input checkbox-display checkbox-display2">
        <v-checkbox class="v-checkbox" v-model="logiall" false-value="0" true-value="1" color="#01c9ff"
          label="생각대로" :disabled="unknown === '1'" @change="
            logiall === '1'
              ? selftypeValue.push('생각대로')
              : (selftypeValue = selftypeValue.filter(
                  (item) => item !== '생각대로'
                ))
          "></v-checkbox>
      </div>

      <div class="insert-content-num-input insert-content-check-input checkbox-display checkbox-display2">
        <v-checkbox class="v-checkbox" v-model="moacall" false-value="0" true-value="1" color="#01c9ff"
          label="모아콜" :disabled="unknown === '1'" @change="
            moacall === '1'
              ? selftypeValue.push('모아콜')
              : (selftypeValue = selftypeValue.filter(
                  (item) => item !== '모아콜'
                ))
          "></v-checkbox>
      </div>
      <div class="insert-content-num-input insert-content-check-input checkbox-display checkbox-display2">
        <v-checkbox class="v-checkbox" v-model="barogo" false-value="0" true-value="1" color="#01c9ff" label="바로고"
          :disabled="unknown === '1'" @change="
            barogo === '1'
              ? selftypeValue.push('바로고')
              : (selftypeValue = selftypeValue.filter(
                  (item) => item !== '바로고'
                ))
          "></v-checkbox>
      </div>

      <div class="insert-content-num-input insert-content-check-input checkbox-display checkbox-display2">
        <v-checkbox class="v-checkbox" v-model="zendelivery" false-value="0" true-value="1" color="#01c9ff"
          label="젠딜리" :disabled="unknown === '1'" @change="
            zendelivery === '1'
              ? selftypeValue.push('젠딜리')
              : (selftypeValue = selftypeValue.filter(
                  (item) => item !== '젠딜리'
                ))
          "></v-checkbox>
      </div>

      <div class="insert-content-num-input insert-content-check-input checkbox-display checkbox-display2">
        <v-checkbox class="v-checkbox" v-model="foodline" false-value="0" true-value="1" color="#01c9ff"
          label="푸드라인" :disabled="unknown === '1'" @change="
            foodline === '1'
              ? selftypeValue.push('푸드라인')
              : (selftypeValue = selftypeValue.filter(
                  (item) => item !== '푸드라인'
                ))
          "></v-checkbox>
      </div>
      <div class="insert-content-num-input insert-content-check-input checkbox-display checkbox-display2">
        <v-checkbox class="v-checkbox" v-model="newtrack" false-value="0" true-value="1" color="#01c9ff"
          label="뉴트랙" :disabled="unknown === '1'" @change="
            newtrack === '1'
              ? selftypeValue.push('뉴트랙')
              : (selftypeValue = selftypeValue.filter(
                  (item) => item !== '뉴트랙'
                ))
          "></v-checkbox>
      </div>
      <div class="insert-content-num-input insert-content-check-input checkbox-display checkbox-display2">
        <v-checkbox class="v-checkbox" v-model="vroong" false-value="0" true-value="1" color="#01c9ff" label="부릉"
          :disabled="unknown === '1'" @change="
            vroong === '1'
              ? selftypeValue.push('부릉')
              : (selftypeValue = selftypeValue.filter(
                  (item) => item !== '부릉'
                ))
          "></v-checkbox>
      </div>
      <div class="insert-content-num-input insert-content-check-input checkbox-display checkbox-display2">
        <v-checkbox class="v-checkbox" v-model="hanaro" false-value="0" true-value="1" color="#01c9ff" label="하나로"
          :disabled="unknown === '1'" @change="
            hanaro === '1'
              ? selftypeValue.push('하나로')
              : (selftypeValue = selftypeValue.filter(
                  (item) => item !== '하나로'
                ))
          "></v-checkbox>
      </div>
      <div class="insert-content-num-input insert-content-check-input checkbox-display checkbox-display2">
        <v-checkbox class="v-checkbox" v-model="spider" false-value="0" true-value="1" color="#01c9ff"
          label="스파이더" :disabled="unknown === '1'" @change="
            spider === '1'
              ? selftypeValue.push('스파이더')
              : (selftypeValue = selftypeValue.filter(
                  (item) => item !== '스파이더'
                ))
          "></v-checkbox>
      </div>
      <div class="insert-content-num-input insert-content-check-input1 checkbox-display checkbox-display2">
        <v-checkbox class="v-checkbox" v-model="baeminandcoupangeats" false-value="0" true-value="1"
          color="#01c9ff" label="배민원, 쿠팡이츠만 이용중" :disabled="unknown === '1'" @change="
            baeminandcoupangeats === '1'
              ? selftypeValue.push('배민원, 쿠팡이츠만 이용중')
              : (selftypeValue = selftypeValue.filter(
                  (item) => item !== '배민원, 쿠팡이츠만 이용중'
                ))
          "></v-checkbox>
      </div>

      <div class="insert-content-num-input insert-content-check-input checkbox-display1 checkbox-display2">
        <v-checkbox class="v-checkbox" v-model="selftype" false-value="0" true-value="1" color="#01c9ff"
          label="직접입력" :disabled="unknown === '1'"></v-checkbox>
      </div>
      <div v-if="selftype == 1">
        <div class="insert-content-delivery-input">
          <v-text-field v-model="inputValue" placeholder="입력후 '추가' 클릭" outlined hide-details dense
            color="#01c9ff"></v-text-field>
        </div>
        <label class="insert-btn-add" @click="addValue">추가</label>
      </div>

    </div>
    <div class="insert-content-left2"></div>
      <div class="insert-content-num-input insert-content-check-input1 checkbox-display1 checkbox-display2">
        <v-checkbox class="v-checkbox" v-model="unknown" false-value="0" true-value="1" color="#01c9ff"
          label="없음" @change="handleUnknownChange"></v-checkbox>
      </div>
  </div>
  <div class="insert-content insert-content-warn" v-if="selftypeValue.length > 0">
    <div class="insert-content-left-warn insert-content-left-space"></div>
    <div class="insert-content-warn-bottom-space">
      <span v-for="(item, index) in selftypeValue" :key="item + index" style="font-size: 18px">{{ item }}
        <button @click="removeValue(index)">
          <v-icon class="insert-icon1" style="font-size: 18px">mdi-close-circle</v-icon>
        </button>
        &nbsp;
      </span>
    </div>
  </div>
  <div class="insert-content insert-content-other1">
    <div class="insert-content-left">약관동의</div>
    <div class="insert-content-store-name-input">
      <div>
        <v-container fluid style="padding: 0">
          <v-checkbox style="margin-bottom: -25px" v-model="checkAgree" value="1" color="#01c9ff">
            <template v-slot:label>
              <div>
                서비스 이용약관 동의(필수)
                <v-tooltip>
                  <template v-slot:activator="{ on }">
                    <a target="_blank" href="https://terms.daeguro.co.kr:45028/agreement/agreement1-1.htm"
                      @click.stop v-on="on" style="
                        margin: 0 0 0 40px;
                        color: #999;
                        text-decoration: none;
                      ">
                      전문보기
                    </a>
                  </template>
                </v-tooltip>
              </div>
            </template>
          </v-checkbox>
          <v-checkbox style="margin-bottom: -25px" v-model="checkAgree2" value="1" color="#01c9ff">
            <template v-slot:label>
              <div>
                개인정보 수집 및 이용동의(필수)
                <v-tooltip>
                  <template v-slot:activator="{ on }">
                    <a target="_blank" href="https://terms.daeguro.co.kr:45028/agreement/agreement7-1.htm"
                      @click.stop v-on="on" style="
                        margin: 0 0 0 8px;
                        color: #999;
                        text-decoration: none;
                      ">
                      전문보기
                    </a>
                  </template>
                </v-tooltip>
              </div>
            </template>
          </v-checkbox>
          <v-checkbox v-model="checkAgree3" value="1" color="#01c9ff">
            <template v-slot:label>
              <div>
                개인정보 수집 및 이용동의(선택)
                <v-tooltip>
                  <template v-slot:activator="{ on }">
                    <a target="_blank" href="https://terms.daeguro.co.kr:45028/agreement/agreement6-2.htm"
                      @click.stop v-on="on" style="
                        margin: 0 0 0 8px;
                        color: #999;
                        text-decoration: none;
                      ">
                      전문보기
                    </a>
                  </template>
                </v-tooltip>
              </div>
            </template>
          </v-checkbox>
        </v-container>
      </div>
    </div>
  </div>

  <!--
  <div class="insert-content insert-content-other insert-content-select">
    <div class="insert-content-left insert-content-left-imp">
      배달 가능 여부<span style="color: #01caff">*</span>
    </div>
    <v-radio-group row hide-details class="insert-radio-group">
      <div class="insert-content-num-input insert-radio-btn">
        <v-radio
          label="배달 / 포장가능"
          color="#01c9ff"
          value="red"
        ></v-radio>
      </div>
      <div class="insert-content-num-input insert-radio-btn">
        <v-radio
          label="배달만 가능"
          color="#01c9ff"
          value="red2"
        ></v-radio>
      </div>
    </v-radio-group>
  </div>
  <div class="insert-content insert-content-other insert-content-select">
    <div class="insert-content-left insert-content-left-use">
      배달 대행사 사용 유무<span style="color: #01caff">*</span>
    </div>
    <v-radio-group row hide-details class="insert-radio-group">
      <div
        class="insert-content-num-input insert-radio-btn insert-radio-btn-1"
      >
        <v-radio label="예" color="#01c9ff" value="red"></v-radio>
      </div>
      <div
        class="insert-content-num-input insert-radio-btn insert-radio-btn-1"
      >
        <v-radio label="아니오" color="#01c9ff" value="red2"></v-radio>
      </div>
    </v-radio-group>
  </div>
  <div
    class="insert-content insert-content-other insert-content-order-checkbox"
  >
    <div class="insert-content-left insert-content-left-space"></div>
    <v-radio-group row hide-details class="insert-radio-group">
      <div
        class="insert-content-checkbox-block insert-radio-btn insert-radio-btn-2"
      >
        <v-radio label="생각대로" color="#01c9ff" value="red"></v-radio>
      </div>
      <div
        class="insert-content-checkbox-block insert-radio-btn insert-radio-btn-2"
      >
        <v-radio label="부릉" color="#01c9ff" value="red2"></v-radio>
      </div>
      <div
        class="insert-content-checkbox-block insert-radio-btn insert-radio-btn-2"
      >
        <v-radio label="바로고" color="#01c9ff" value="red3"></v-radio>
      </div>
      <div
        class="insert-content-checkbox-block insert-radio-btn insert-radio-btn-2"
      >
        <v-radio label="공유다" color="#01c9ff" value="red4"></v-radio>
      </div>
      <div
        class="insert-content-checkbox-block insert-radio-btn insert-radio-btn-2"
      >
        <v-radio label="기타" color="#01c9ff" value="red5"></v-radio>
      </div>
      <div class="insert-content-rider-name-input">
        <v-text-field
          placeholder="배달대행사 명"
          outlined
          hide-details
        ></v-text-field>
      </div>
    </v-radio-group>
  </div> -->
</div>
<div class="insert-btn-block">
<div
  class="real-insert-btn"
  :class="{ disabled: sendInsertReq }"
  @click="!sendInsertReq && goEnter()"
>
  {{ sendInsertReq ? "접수 중..." : "입점 신청 완료" }}
</div>
  <router-link :to="{ name: 'Enter_Info' }" class="real-insert-btn real-insert-btn-back">
    이전
  </router-link>
</div>
<v-dialog v-model="dialog" persistent width="500">
  <v-card>
    <v-card-title class="dialog-title">
      <div>주소 검색</div>
    </v-card-title>

    <v-divider></v-divider>

    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="#01c9ff" dark depressed @click="dialog = false">
        닫기
      </v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>
</v-container>
</div>
</template>
<script src="//t1.kakaocdn.net/mapjsapi/bundle/postcode/prod/postcode.v2.js"></script>
<script>
import Sms from "@/api/Sms";
import Shop from "@/api/Shop";
import Account from "@/api/Account";
import Compressor from "compressorjs";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import defaultLogo from "@/assets/imgs/logo_daegurostore.jpg";

export default {
async created() {
window.scrollTo(0, 0);
},
components: {
Loading,
},
watch: {
bank_name() {
  this.isCheckBank = false; // 값 바뀌면 인증 초기화
},
bank_account_num() {
  this.isCheckBank = false;
},
bank_account_name() {
  this.isCheckBank = false;
},
/**
  각 필드에 입력 시 regix 이용하여 조건에 맞도록 넘김
*/
ceo_phone1(text) {
  this.$nextTick(() => {
    this.ceo_phone1 = text.replace(/[^0-9]/g, "");
    this.ceo_phone = `${this.ceo_phone1}${this.ceo_phone2}${this.ceo_phone3}`;
  });
},
ceo_phone2(text) {
  this.$nextTick(() => {
    this.ceo_phone2 = text.replace(/[^0-9]/g, "");
    this.ceo_phone = `${this.ceo_phone1}${this.ceo_phone2}${this.ceo_phone3}`;
  });
},
ceo_phone3(text) {
  this.$nextTick(() => {
    this.ceo_phone3 = text.replace(/[^0-9]/g, "");
    this.ceo_phone = `${this.ceo_phone1}${this.ceo_phone2}${this.ceo_phone3}`;
  });
},
shop_tel1(text) {
  this.$nextTick(() => {
    this.shop_tel1 = text.replace(/[^0-9]/g, "");
    if (!this.shop_tel3 || this.shop_tel3 === "") {
      this.shop_tel = `${this.shop_tel1}${this.shop_tel2}`;
    } else {
      this.shop_tel = `${this.shop_tel1}${this.shop_tel2}${this.shop_tel3}`;
    }
  });
},
shop_tel2(text) {
  this.$nextTick(() => {
    this.shop_tel2 = text.replace(/[^0-9]/g, "");
    if (!this.shop_tel3 || this.shop_tel3 === "") {
      this.shop_tel = `${this.shop_tel1}${this.shop_tel2}`;
    } else {
      this.shop_tel = `${this.shop_tel1}${this.shop_tel2}${this.shop_tel3}`;
    }
  });
},
shop_tel3(text) {
  this.$nextTick(() => {
    this.shop_tel3 = text.replace(/[^0-9]/g, "");
  });
  if (!this.shop_tel3 || this.shop_tel3 === "") {
    this.shop_tel = `${this.shop_tel1}${this.shop_tel2}`;
  } else {
    this.shop_tel = `${this.shop_tel1}${this.shop_tel2}${this.shop_tel3}`;
  }
},
ceo_phone() {
  this.isExpired = false;
  this.isPhoneChecked = false;
  this.notGoCode = false;
  this.nonePhone = false;
  this.goneCode = false;
  this.codeErr = false;
},
check_cert(text) {
  if (text) {
    this.$nextTick(() => {
      this.check_cert = text.replace(/[^0-9]/g, "");
    });
  }
},
shop_reg_no1(text) {
  if (text) {
    this.$nextTick(() => {
      this.shop_reg_no1 = text.replace(/[^0-9]/g, "");
      this.shop_reg_no = `${this.shop_reg_no1}${this.shop_reg_no2}${this.shop_reg_no3}`;
    });
  }
},
shop_reg_no2(text) {
  if (text) {
    this.$nextTick(() => {
      this.shop_reg_no2 = text.replace(/[^0-9]/g, "");
      this.shop_reg_no = `${this.shop_reg_no1}${this.shop_reg_no2}${this.shop_reg_no3}`;
    });
  }
},
shop_reg_no3(text) {
  if (text) {
    this.$nextTick(() => {
      this.shop_reg_no3 = text.replace(/[^0-9]/g, "");
      this.shop_reg_no = `${this.shop_reg_no1}${this.shop_reg_no2}${this.shop_reg_no3}`;
    });
  }
},
shop_reg_no() {
  this.checkedDuplicate = false;
},
/*shop_file_no1(text) {
  if (text) {
    this.$nextTick(() => {
      this.shop_file_no1 = this.type.match(/^image\/(png|jpeg)$/)
    });
  }
},
shop_file_no2(text) {
  if (text) {
    this.$nextTick(() => {
      this.shop_file_no2 = this.type.match(/^image\/(png|jpeg)$/)
    });
  }
},
shop_file_no3(text) {
  if (text) {
    this.$nextTick(() => {
      this.shop_file_no3 = this.type.match(/^image\/(png|jpeg)$/)
    });
  }
},*/
email_address_sel() {
  if (this.email_address_sel === this.email_category[11]) {
    this.email_address = "";
    this.disabled = false;
  } else if (this.email_address_sel === this.email_category[0]) {
    this.email_address = "";
    this.disabled = true;
  } else {
    this.email_address = this.email_address_sel;
    this.disabled = true;
  }
},
email_id() {
  this.email = `${this.email_id}${this.email_le}${this.email_address}`;
},
email_address() {
  this.email = `${this.email_id}${this.email_le}${this.email_address}`;
},
},
data() {
return {
    isLoading: false,
    sendInsertReq: false,
    percentCompleted: 0,
  category: [
    {
      code: "",
      name: "선택없음",
    },
    {
      code: "1001",
      name: "치킨/찜닭",
    },
    {
      code: "1004",
      name: "중식",
    },
    {
      code: "1005",
      name: "분식",
    },
    {
      code: "1008",
      name: "한식",
    },
    {
      code: "1003",
      name: "피자",
    },
    {
      code: "1006",
      name: "족발/보쌈",
    },
    {
      code: "1024",
      name: "패스트푸드",
    },
    {
      code: "1013",
      name: "돈까스/일식",
    },
    {
      code: "1025",
      name: "도시락/죽",
    },
    {
      code: "1026",
      name: "카페/디저트",
    },
    {
      code: "1014",
      name: "아시안/양식",
    },
    {
      code: "1007",
      name: "야식",
    },
  ],
  display: false,
  disabled: true,
  email_le: "@",
  email_id: null,
  email_address: null,
  email_address_sel: "이메일을 선택하세요",
  email_category: [
    "이메일을 선택하세요",
    "naver.com",
    "gmail.com",
    "hanmail.net",
    "nate.com",
    "yahoo.co.kr",
    "yahoo.com",
    "dreamwiz.com",
    "chol.com",
    "empal.com",
    "korea.com",
    "직접입력",
  ],
  phone1: ["010", "011", "016", "017", "018", "019"],
  tel1: ["053", "010", "070"],
  banks: ["산업", "기업", "국민", "외환", "수협", "수출", "농협", "단협/축협", "우리", "SC은행", "씨티", "부산", "광주", "제주", "전북", "경남", "우체국", "KEB하나", "신한", "대구", "상호저축", "신협", "새마을", "K뱅크", "카카오뱅크", "산림조합", "토스"],
  bank_name: "",
  bank_code: "",
  bank_account_num: "",
  bank_account_name: "",
  dialog: false,
  expired_time: 3 * 60,
  resTimeData: "",
  enc: null,
  shop_reg_no: null,
  shop_reg_no1: null,
  shop_reg_no2: null,
  shop_reg_no3: null,
  shop_file_no1: null,
  shop_file_no2: null,
  shop_file_no3: null,
  shop_name: null,
  shop_ceo: null,
  ceo_phone: null,
  ceo_phone1: "010",
  ceo_phone2: null,
  ceo_phone3: null,
  ceo_sub_phone: null,
  ceo_sub_phone1: "010",
  ceo_sub_phone2: null,
  ceo_sub_phone3: null,
  shop_tel1: "053",
  shop_tel2: null,
  shop_tel3: null,
  shop_address: null,
  shop_address_detail: null,
  // shop_item1: "",
  // shop_item2: "",
  // shop_item3: "",
  shop_type: null,
  delivery_app_state: null,
  delivery_app_type: null,
  delivery_etc_name: null,
  check_cert: null,
  isExpired: false,
  isPhoneChecked: false,
  polling: null,
  zip_code: null,
  isDuplicated: false,
  isNotValid: false,
  checkedDuplicate: false,
  isBisNumErr: false,
  isCheckBank: false,
  notGoCode: false,
  nonePhone: false,
  goneCode: false,
  codeErr: false,
  checkAgree: 0,
  checkAgree2: 0,
  checkAgree3: 0,
  file_name_no1: "사업자등록증을 업로드해주세요.",
  file_name_no2: "영업신고증을 업로드해주세요.",
  file_name_no3: "통장사본을 업로드해주세요.",
  email: "",
  checkdelivery: "0",
  checkpackaging: "0",
  checkreservation: "0",
  checkLogoCreate: "0",
  otherplatform: "",
  serviceType: "0",
  joinReason: "1",
  unknown: "0",
  logiall: "0",
  manna: "0",
  zendelivery: "0",
  foodline: "0",
  baeminandcoupangeats: "0",
  spider: "0",
  newtrack: "0",
  vroong: "0",
  moacall: "0",
  barogo: "0",
  bbaliwa: "0",
  hanaro: "0",
  selftype: "0",
  inputValue: "",
  selftypeValue: [],
  shopMemo: "",
  shopType: "",
  shop_logo_preview: null, // 업로드 이미지 미리보기용
  defaultLogo,             // 기본 이미지
};
},
computed: {
shopLogoSrc() {
  return this.shop_logo_preview || this.defaultLogo;
}
},
/*data() {
return {
  category: [
    {
      code: "",
      name: "선택없음",
    },
    {
      code: "1001",
      name: "치킨/찜닭",
    },
    {
      code: "1004",
      name: "중식",
    },
    {
      code: "1005",
      name: "분식",
    },
    {
      code: "1008",
      name: "한식",
    },
    {
      code: "1003",
      name: "피자",
    },
    {
      code: "1006",
      name: "족발/보쌈",
    },
    {
      code: "1024",
      name: "패스트푸드",
    },
    {
      code: "1013",
      name: "돈까스/일식",
    },
    {
      code: "1025",
      name: "도시락/죽",
    },
    {
      code: "1026",
      name: "카페/디저트",
    },
    {
      code: "1014",
      name: "아시안/양식",
    },
    {
      code: "1007",
      name: "야식",
    },
  ],
  phone1: ["010", "011", "016", "017", "018", "019"],
  dialog: false,
  expired_time: 3 * 60,
  resTimeData: "",
  enc: null,
  shop_reg_no: null,
  shop_reg_no1: "503",
  shop_reg_no2: "81",
  shop_reg_no3: null,
  shop_file_no1: null,
  shop_file_no2: null,
  shop_file_no3: null,
  shop_name: "test",
  shop_ceo: "test",
  ceo_phone: "010",
  ceo_phone1: "010",
  ceo_phone2: "1234",
  ceo_phone3: "1234",
  shop_tel1: "053",
  shop_tel2: "1234",
  shop_tel3: "1234",
  shop_address: "test",
  shop_address_detail: "test",
  shop_item1: "1",
  shop_item2: "1",
  shop_item3: "1",
  shop_type: null,
  delivery_app_state: null,
  delivery_app_type: null,
  delivery_etc_name: null,
  check_cert: null,
  isExpired: false,
  isPhoneChecked: false,
  polling: null,
  zip_code: null,
  isDuplicated: false,
  isNotValid: false,
  checkedDuplicate: false,
  isBisNumErr: false,
  notGoCode: false,
  nonePhone: false,
  goneCode: false,
  codeErr: false,
  checkAgree: false,
  file_name_no1: "사업자등록증을 업로드해주세요.",
  file_name_no2: "영업신고증을 업로드해주세요.",
  file_name_no3: "통장사본을 업로드해주세요.",
};
},*/
beforeDestroy() {
clearInterval(this.polling);
},
methods: {
  // kakao 우편번호 검색 추가, dialog에서 이 방식으로 변경
  openPostcode() {
    if (!window.kakao || !window.kakao.Postcode) {
      const script = document.createElement("script");
      script.src =
        "//t1.kakaocdn.net/mapjsapi/bundle/postcode/prod/postcode.v2.js";

      script.onload = () => {
        new window.kakao.Postcode({
          oncomplete: (data) => {
            this.execPostcode(data);
          },
        }).open();
      };

      document.head.appendChild(script);
      return;
    }

    new window.kakao.Postcode({
      oncomplete: (data) => {
        this.execPostcode(data);
      },
    }).open();
  },

forceNumber(e) {
  const clean = e.target.value.replace(/\D/g, '');
  if (e.target.value !== clean) {
    e.target.value = clean;          // 실제 화면 값 교체
    this.bank_account_num = clean;   // v-model 값 교체
  }
},
bankCheckMethod() {
  // 확인 버튼 클릭 시 숫자만 보장
  this.bank_account_num = this.bank_account_num.replace(/\D/g, '');
  this.isCheckBank = true;
},
/*
파일업로드
*/
compress(file) {
  return new Promise((resolve, reject) => {
    new Compressor(
      file,
      Object.assign({
        strict: true,
        convertSize: 20000000,
        quality: 0.6,
        success: (result) => {
          return resolve(result);
        },
        error: (err) => {
          return reject(err);
        },
      })
    );
  });
},
blobToFile(theBlob, fileName) {
  return new File([theBlob], fileName, {
    lastModified: new Date().getTime(),
    type: theBlob.type,
  });
},
// onDrop (event) {
//   this.inputImageFile_no_1(event.dataTransfer.files)
//   this.inputImageFile_no_2(event.dataTransfer.files)
//   this.inputImageFile_no_3(event.dataTransfer.files)
// },
async inputImageFile_no_1(files) {
  if (files.length) {
    let file = files[0];
    if (!/^image\//.test(file.type)) {
      alert("이미지 파일만 등록이 가능합니다");
      this.file_name_no1 = "사업자등록증을 업로드해주세요.";
      this.shop_file_no1 = null;
      this.$refs.shop_file_no1.value = "";
      return false;
    }
    if (file.size > 1.4 * 1024 * 1024) {
      await this.compress(file)
        .then((result) => {
          this.shop_file_no1 = this.blobToFile(result, this.file_name_no1);
          // console.log(this.shop_file_no1 instanceof File)
        })
        .catch((error) => {
          console.log(error);
          alert("이미지 업로드 중 오류가 발생하였습니다");
          this.file_name_no1 = "사업자등록증을 업로드해주세요.";
          this.shop_file_no1 = null;
          this.$refs.shop_file_no1.value = "";
          return false;
        });
    } else {
      this.shop_file_no1 = file;
    }
  } else {
    this.file_name_no1 = "사업자등록증을 업로드해주세요.";
    this.shop_file_no1 = null;
    this.$refs.shop_file_no1.value = "";
    return false;
  }
  // console.log(this.shop_file_no1);
},
async inputImageFile_no_2(files) {
  if (files.length) {
    let file = files[0];
    if (!/^image\//.test(file.type)) {
      alert("이미지 파일만 등록이 가능합니다");
      this.file_name_no2 = "영업신고증을 업로드해주세요.";
      this.shop_file_no2 = null;
      this.$refs.shop_file_no2.value = "";
      return false;
    }
    if (file.size > 1.4 * 1024 * 1024) {
      await this.compress(file)
        .then((result) => {
          this.shop_file_no2 = this.blobToFile(result, this.file_name_no2);
          // console.log(this.shop_file_no2 instanceof File)
        })
        .catch((error) => {
          console.log(error);
          alert("이미지 업로드 중 오류가 발생하였습니다");
          this.file_name_no2 = "영업신고증을 업로드해주세요.";
          this.shop_file_no2 = null;
          this.$refs.shop_file_no2.value = "";
          return false;
        });
    } else {
      this.shop_file_no2 = file;
    }
  } else {
    alert("이미지 업로드 중 오류가 발생하였습니다");
    this.file_name_no2 = "영업신고증을 업로드해주세요.";
    this.shop_file_no2 = null;
    this.$refs.shop_file_no2.value = "";
    return false;
  }
  // console.log(this.shop_file_no2);
},
async inputImageFile_no_3(files) {
  if (files.length) {
    let file = files[0];
    if (!/^image\//.test(file.type)) {
      alert("이미지 파일만 등록이 가능합니다");
      this.file_name_no3 = "통장사본을 업로드해주세요.";
      this.shop_file_no3 = null;
      this.$refs.shop_file_no3.value = "";
      return false;
    }
    if (file.size > 1.4 * 1024 * 1024) {
      await this.compress(file)
        .then((result) => {
          this.shop_file_no3 = this.blobToFile(result, this.file_name_no3);
          // console.log(this.shop_file_no3 instanceof File)
        })
        .catch((error) => {
          console.log(error);
          alert("이미지 업로드 중 오류가 발생하였습니다");
          this.file_name_no3 = "통장사본을 업로드해주세요.";
          this.shop_file_no3 = null;
          this.$refs.shop_file_no3.value = "";
          return false;
        });
    } else {
      this.shop_file_no3 = file;
    }
  } else {
    alert("이미지 업로드 중 오류가 발생하였습니다");
    this.file_name_no3 = "통장사본을 업로드해주세요.";
    this.shop_file_no3 = null;
    this.$refs.shop_file_no3.value = "";
    return false;
  }
  // console.log(this.shop_file_no3);
},
handleFileUpload_no1(e) {
  if (!e.target.files || !e.target.files.length) {
    return;
  }
  this.file_name_no1 = e.target.files[0].name;
  this.inputImageFile_no_1(e.target.files);
}, 
handleFileUpload_no2(e) {
  if (!e.target.files || !e.target.files.length) {
    return;
  }
  this.file_name_no2 = e.target.files[0].name;
  this.inputImageFile_no_2(e.target.files);
},
handleFileUpload_no3(e) {
  if (!e.target.files || !e.target.files.length) {
    return;
  }
  this.file_name_no3 = e.target.files[0].name;
  this.inputImageFile_no_3(e.target.files);
},
/**
다음 주소창 리턴 함수
*/
execPostcode(data) {
  this.shop_address = `${data.roadAddress || data.autoRoadAddress} ${data.buildingName}`; // 수정

  if (data.jibunAddress == "" || data.jibunAddress == null) {
    this.addr1 = data.autoJibunAddress; //v[1] -> formData.addr1
  } else {
    this.addr1 = data.jibunAddress; //v[1] -> formData.addr1
  }

  this.addr2 = data.roadAddress || data.autoRoadAddress; // 수정
  this.sidoName = data.sido;
  this.gunguName = data.sigungu;
  //this.bname1 = data.bname1;
  this.road = data.roadname;
  this.hdong = data.hname;
  //this.bname2 = data.bname2;
  this.buildingName = data.buildingName;
  //this.autoJibunAddress = data.autoJibunAddress;
  this.zipCode = data.zonecode; //v[0] -> formData.zipCode

  this.roadDestBuilding =
    data.buildingName == "" ? "string" : data.buildingName;

  if (data.bname1 == "") {
    this.roadDestDong = data.roadname; //formData.roadDestDong = v[6];
    this.dongName = data.bname2; //formData.dongName = v[8];
    this.bdong = data.bname2; //shopPosUpdate.bdong = v[8];
  } else {
    this.roadDestDong = data.roadname; //formData.roadDestDong = v[6];
    // this.roadDestDong = data.bname1 + ' ' + data.roadname;//formData.roadDestDong = v[5] + ' ' + v[6];
    this.dongName = data.bname1 + " " + data.bname2; //formData.dongName = v[5] + ' ' + v[8];
    this.bdong = data.bname1; //shopPosUpdate.bdong = v[5];
    this.ri = data.bname2; //shopPosUpdate.ri = v[8];
  }

  let addr1Arr = this.addr1.split(" ");
  let addr2Arr = this.addr2.split(" ");

  this.destJibun = addr1Arr[addr1Arr.length - 1];
  this.roadDestAddr = addr2Arr[addr2Arr.length - 1];

  this.dialog = false;
},
/*
타임 시작 함수 (인증번호 만료 시간에 사용)
*/
start() {
  if (!this.polling) {
    this.expired_time--;
    this.polling = setInterval(() => {
      this.expired_time--;
      if (this.expired_time <= 0) this.timeStop();
    }, 1000);
  }
},
/*
인증번호 요청 함수
*/
async goCode() {
  if (
    this.ceo_phone &&
    this.$_validPhone1(this.ceo_phone2) &&
    this.$_validPhone2(this.ceo_phone3)
  ) {
    const { data: enc } = await Sms.createEnc();
    this.cert_num = enc.body.cert_num;
    const smsInfo = {
      phone: this.ceo_phone,
      cert_num: this.cert_num,
    };
    this.expired_time = 3 * 60;
    await Sms.sendSms(smsInfo);
    this.start();
    this.goneCode = true;
    this.isExpired = false;
    this.notGoCode = false;
    this.nonePhone = false;
    this.isPhoneChecked = false;
    this.codeErr = false;
  } else {
    this.notGoCode = false;
    this.isExpired = false;
    this.isPhoneChecked = false;
    this.nonePhone = true;
    this.goneCode = false;
    this.codeErr = false;
  }
},
/**
타이머 멈추는 함수
*/
timeStop() {
  clearInterval(this.polling);
  this.isExpired = true;
},
/**
인증번호 비교 함수
*/
async goCheckCode() {
  if (this.polling) {
    const checkInfo = {
      check_cert: this.check_cert,
      cert_num: this.cert_num,
    };
    const { data: checkRes } = await Sms.checkCert(checkInfo);
    if (checkRes.statusCode == 200) {
      this.isPhoneChecked = true;
      this.isExpired = false;
      this.notGoCode = false;
      this.nonePhone = false;
      this.goneCode = false;
      this.codeErr = false;
    } else {
      this.codeErr = true;
      this.isExpired = false;
      this.notGoCode = false;
      this.nonePhone = false;
      this.goneCode = false;
      this.isPhoneChecked = false;
    }
  } else {
    this.notGoCode = true;
    this.isExpired = false;
    this.isPhoneChecked = false;
    this.nonePhone = false;
    this.goneCode = false;
    this.codeErr = false;
  }
},
/**
중복 체크 함수
*/
async goDupCheck() {
  try {
    if (this.shop_reg_no && this.$_validBisNo(this.shop_reg_no)) {
      console.log(">> goDupCheck 요청 데이터:", { shop_reg_no: this.shop_reg_no });
      const { data: res } = await Shop.checkRegNo(this.shop_reg_no);
      console.log(">> goDupCheck 응답 데이터:", res);
      //console.log(`[response] checkRegNo -> code:${res.code} ret:${res.msg}`);
      // let isDup = res.body.ret === "False" ? 0 : 1;

      console.log(res.code);
      console.log(res.msg);

      if (res.code == 200) {
        this.checkedDuplicate = true; //입점가능 유무
        this.isDuplicated = false; //이미등록된 가맹점인지 유무
        this.isBisNumErr = false; //사업자번호 유효성 유무
      } else if (res.code == 98) {
        this.checkedDuplicate = false; //입점가능 유무
        this.isDuplicated = false; //이미등록된 가맹점인지 유무
        this.isBisNumErr = true; //사업자번호 유효성 유무
      } else {
        this.checkedDuplicate = false;
        this.isDuplicated = true;
        this.isBisNumErr = false;
      }
    } else {
      this.checkedDuplicate = false;
      this.isDuplicated = false;
      this.isBisNumErr = true;
    }
  } catch (e) {
    console.error(">> goDupCheck 에러:", e);
    alert("중복조회에 실패했습니다.");
  }
},
async bankCheck() {
  try {
    if (this.bank_name && this.bank_account_num && this.bank_account_name) {
      this.bank_code = "";

      switch (this.bank_name) {
        case "산업":
          this.bank_code = "02";
          break;
        case "기업":
          this.bank_code = "03";
          break;
        case "국민":
          this.bank_code = "04";
          break;
        case "외환":
          this.bank_code = "05";
          break;
        case "수협":
          this.bank_code = "07";
          break;
        case "수출":
          this.bank_code = "08";
          break;
        case "농협":
          this.bank_code = "11";
          break;
        case "단협/축협":
          this.bank_code = "12";
          break;
        case "우리":
          this.bank_code = "20";
          break;
        case "SC은행":
          this.bank_code = "23";
          break;
        case "씨티":
          this.bank_code = "27";
          break;
        case "부산":
          this.bank_code = "32";
          break;
        case "광주":
          this.bank_code = "34";
          break;
        case "제주":
          this.bank_code = "35";
          break;
        case "전북":
          this.bank_code = "37";
          break;
        case "경남":
          this.bank_code = "39";
          break;
        case "우체국":
          this.bank_code = "71";
          break;
        case "KEB하나":
          this.bank_code = "81";
          break;
        case "신한":
          this.bank_code = "88";
          break;
        case "대구":
          this.bank_code = "31";
          break;
        case "상호저축":
          this.bank_code = "50";
          break;
        case "신협":
          this.bank_code = "48";
          break;
        case "새마을":
          this.bank_code = "45";
          break;
        case "K뱅크":
          this.bank_code = "89";
          break;
        case "카카오뱅크":
          this.bank_code = "90";
          break;
        case "산림조합":
          this.bank_code = "64";
          break;
        case "토스":
          this.bank_code = "92";
          break;
      }

      console.log(">> bankCheck 요청 데이터:", { shop_reg_no: this.shop_reg_no });
      const { data: res } = await Account.account(this.bank_code, this.bank_account_num, this.bank_account_name);
      console.log(">> bankCheck 응답 데이터:", res);

      console.log(res.code);
      console.log(res.msg);

      if (res.code == '0000') {
        this.isCheckBank = true;
      }
      else if (res.code == 'D059') {
        this.isCheckBank = false;
        alert("예금주명을 다시 입력해주세요.(실제 예금주: " + res.accountName + ")");
      }
      else {
        this.isCheckBank = false;
        alert(res.msg);
      }
    } else {
      this.isCheckBank = false;
      alert("정산계좌정보를 정확하게 입력해주세요.");
    }
  } catch (e) {
    console.error(">> goDupCheck 에러:", e);
    alert("중복조회에 실패했습니다.");
  }
},
async goEnter() {
  this.shopMemo = "";
  this.shopType = "";

  if (!this.shop_reg_no1) {
    alert("사업자 등록 번호를 확인하세요.");
    return false;
  }

  if (!this.shop_reg_no2) {
    alert("사업자 등록 번호를 확인하세요.");
    return false;
  }

  if (!this.shop_reg_no3) {
    alert("사업자 등록 번호를 확인하세요.");
    return false;
  }

  if (this.isDuplicated) {
    alert("사업자 등록 번호를 확인하세요.");
    return false;
  }

  if (this.isBisNumErr) {
    alert("사업자 등록 번호를 확인하세요.");
    return false;
  }

  if (!this.checkedDuplicate) {
    alert("사업자 등록 번호 중복 조회하세요.");
    return false;
  }


  this.shopMemo = "입점사유: ";

  switch (this.joinReason) {
    case "1":
      this.shopMemo += "신규";
      break;
    case "2":
      this.shopMemo += "해지 후 재입점";
      break;
    case "3":
      this.shopMemo += "양도양수";
      break;
    case "4":
      this.shopMemo += "명의변경";
  }

  if (this.ceo_sub_phone1 && this.ceo_sub_phone2 && this.ceo_sub_phone3) {
    this.shopMemo += `\n부재시 연락가능번호: ${this.ceo_sub_phone1}-${this.ceo_sub_phone2}-${this.ceo_sub_phone3}`;
  }

  if (this.checkLogoCreate === "1") {
    this.shopMemo += `\n로고제작요청: O`;
  } else {
    this.shopMemo += `\n로고제작요청: X`;
  }

  if (this.otherplatform === "0") {
    this.shopMemo += "\n타플랫폼 사용 여부: X";
    if (this.unknown === "1") {
      this.shopMemo += "\n배달업체: 없음";
    }
    if (this.selftypeValue.length > 0) {
      this.shopMemo += "\n배달업체: " + this.selftypeValue.join(", ");
    }
  } else if (this.otherplatform === "1") {
    this.shopMemo += "\n타플랫폼 사용 여부: O";
    if (this.unknown === "1") {
      this.shopMemo += "\n배달업체: 없음";
    }
    if (this.selftypeValue.length > 0) {
      this.shopMemo += "\n배달업체: " + this.selftypeValue.join(", ");
    }
  }

  // if (this.checkdelivery === "5" && this.checkpackaging === "7") {
  //   this.shopType = "5,7";
  // } else if (this.checkdelivery === "5") {
  //   this.shopType = "5";
  // } else if (this.checkpackaging === "7") {
  //   this.shopType = "7";
  // } else {
  //   this.shopType = "";
  // }

  switch (this.serviceType) {
    case "0":
      this.shopType = "5,7";
      break;

    case "1":
      this.shopType = "5";
      break;

    case "2":
      this.shopType = "7";
      break;
  }

  if (!this.shop_name) {
    alert("매장 명을 확인하세요.");
    return false;
  }
  if (!this.shop_ceo) {
    alert("사업주 명을 확인하세요.");
    return false;
  }
  if (!this.ceo_phone) {
    alert("사업주 휴대전화번호를 확인하세요.");
    return false;
  }
  if (!this.ceo_phone1) {
    alert("사업주 휴대전화번호를 확인하세요.");
    return false;
  }
  if (!this.ceo_phone2) {
    alert("사업주 휴대전화번호를 확인하세요.");
    return false;
  }
  if (!this.ceo_phone3) {
    alert("사업주 휴대전화번호를 확인하세요.");
    return false;
  }
  if (!this.shop_address) {
    alert("매장 주소를 확인하세요.");
    return false;
  }
  if (!this.shop_address_detail) {
    alert("매장 상세주소를 확인하세요.");
    return false;
  }
  // if (!this.shop_item1 || this.shop_item1 === "") {
  //   alert("업종 카테고리는 필수입니다.");
  //   return false;
  // }
  if (!this.shop_tel || !this.shop_tel1 || !this.shop_tel2) {
    alert("매장 전화번호는 필수입니다.");
    return false;
  }
  if (!this.email_id || !this.email_address) {
    alert("이메일 주소를 확인하세요.");
    return false;
  }
  if (!this.shop_file_no1) {
    alert("사업자등록증을 업로드해주세요.");
    return false;
  }
  if (!this.shop_file_no2) {
    alert("영업신고증을 업로드해주세요.");
    return false;
  }
  if (!this.shop_file_no3) {
    alert("통장사본을 업로드해주세요.");
    return false;
  }

  /*
  if (this.bank_name == null || this.bank_name == '') {
    alert("은행을 선택해주세요.");
    return false;
  }

  if (this.bank_account_num == null || this.bank_account_num == '') {
    alert("계좌번호를 입력해주세요.");
    return false;
  }

  if (this.bank_account_name == null || this.bank_account_name == '') {
    alert("예금주명을 입력해주세요.");
    return false;
  }
  if (this.isCheckBank == false) {
    alert("정산계좌 확인을 해주세요.");
    return false;
  }
  */

  if (!this.otherplatform) {
    alert("타 플랫폼 사용여부를 확인하세요.");
    return false;
  }

  if(this.shopType == null || this.shopType == '') {
    alert("서비스 형태를 확인하세요.");
    return false;
  }
  

  // if (this.checkdelivery == "0" && this.checkpackaging == "0") {
  //   // jskang 220823: 초기값과 체크 해제시 값이 null이 아니므로 해당 if 구문에 오류가 있어 null체크가 아닌 '0'인지 체크하도록 수정
  //   alert("서비스 형태를 확인하세요.");
  //   return false;
  // }
  if (!this.checkAgree) {
    alert("서비스 이용약관에 동의하세요.");
    return false;
  }
  if (!this.checkAgree2) {
    alert("개인정보 수집 및 이용에 동의하세요.");
    return false;
  }

  // 이메일 검증 스크립트 작성
  const regExp =
    /^[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*@[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*.[a-zA-Z]{2,3}$/i;
  // 검증에 사용할 정규식 변수 regExp에 저장
  if (this.email.match(regExp) != null) {         

   if (this.sendInsertReq) {
      alert("현재 입점 신청 중입니다. 잠시만 기다려 주세요.");
      return false;
    }

    this.sendInsertReq = true;
    this.isLoading = true;

    try {
      var formData = new FormData();

      formData.append("jobGbn", "I");
      formData.append("testGbn", "R");
      /*
      formData.append("deliAppYn", "string");
      formData.append("deliAppType", "string");
      formData.append("deliEtcName", "string");
      */
      formData.append("regNo", this.shop_reg_no);
      formData.append("owner", this.shop_ceo);
      formData.append("mobile", this.ceo_phone);
      // formData.append("zipCode", this.zipCode);
      formData.append("addr1", this.addr1);
      formData.append("addr2", this.addr2);
      /*
      formData.append("sidoName", this.sidoName);
      formData.append("gunguName", this.gunguName);
      formData.append("dongName", this.dongName);
      formData.append("destJibun", this.destJibun);
      formData.append("roadDestDong", this.roadDestDong);
      formData.append("roadDestAddr", this.roadDestAddr);
      formData.append("roadDestBuilding", this.roadDestBuilding);
      */
      formData.append("loc", this.shop_address_detail);
      /*
      formData.append("road", this.road);
      formData.append("hdong", this.hdong);
      formData.append("bdong", this.bdong);
      formData.append("ri", this.ri);
      */
      formData.append("shopName", this.shop_name);
      formData.append("shopTelno", this.shop_tel);
      formData.append("memo", this.shopMemo);
      formData.append("email", this.email ? this.email.trim() : "");
      formData.append("shopType", this.shopType);
      formData.append("personInfoUseGbn", this.checkAgree2);
      formData.append("appUseConfGbn", this.checkAgree);
      formData.append("selectivePrivacyTerms", this.checkAgree3 ? this.checkAgree3 : "0");
      formData.append("bankCode", this.bank_code);
      formData.append("bankName", this.bank_name);
      formData.append("bankAccountNum", this.bank_account_num);
      formData.append("bankAccountName", this.bank_account_name);

      // 파일
      formData.append("formFile1", this.shop_file_no1);
      formData.append("formFile2", this.shop_file_no2);
      formData.append("formFile3", this.shop_file_no3);

      const { data: res } = await Shop.setShopInfoJoinStatusV2(
        formData,
        percent => {
          this.uploadPercent = percent;
        }
      );

      if (res.code == "00") {
        alert("접수완료: " + res.msg);
        this.$router.push({ name: "Enter_Complete" });
      } else {
        alert("서버에 에러가 발생하였습니다.\n에러 내용: " + res.msg);
        return false;
      }

    } catch (err) {
      console.error(err);

      if (err.code === "ECONNABORTED") {
        alert("접수 처리 시간이 지연되고 있습니다.\n신청이 접수되었을 수 있으니 잠시 후 확인해 주세요.");
      } else if (err.response?.status === 413) {
        alert("첨부파일 용량이 너무 큽니다.\n파일 크기를 줄인 후 다시 시도해 주세요.");
      } else if (err.response?.status === 500) {
        alert("일시적인 오류가 발생했습니다.\n잠시 후 다시 시도해 주세요.");
      } else {
        alert("입점 신청 중 오류가 발생했습니다.\n잠시 후 다시 시도해 주세요.");
      }

      return false;

    } finally {
      this.sendInsertReq = false;
      this.isLoading = false;
    }
  } else {
    alert("이메일 주소를 확인하세요.");
  }
},
addValue() {
  if (this.inputValue != "") {
    this.selftypeValue.push(this.inputValue);
    this.inputValue = "";
  }
},
removeValue(index) {
  console.log(this.selftypeValue[index]);
  switch (this.selftypeValue[index]) {
    case "생각대로":
      this.logiall = "0";
      break;
    case "만나":
      this.manna = "0";
      break;
    case "젠딜리":
      this.zendelivery = "0";
      break;
    case "푸드라인":
      this.foodline = "0";
      break;
    case "배민원, 쿠팡이츠만 이용중":
      this.baeminandcoupangeats = "0";
      break;
    case "스파이더":
      this.spider = "0";
      break;
    case "뉴트랙":
      this.newtrack = "0";
      break;
    case "부릉":
      this.vroong = "0";
      break;
    case "모아콜":
      this.moacall = "0";
      break;
    case "바로고":
      this.barogo = "0";
      break;
    case "빨리와":
      this.bbaliwa = "0";
      break;
    case "하나로":
      this.hanaro = "0";
      break;

    default:
      break;
  }
  this.selftypeValue.splice(index, 1);
},
handleUnknownChange() {
  if (this.unknown === "1") {
    this.selftypeValue = [];
    this.logiall = "0";
    this.manna = "0";
    this.zendelivery = "0";
    this.foodline = "0";
    this.baeminandcoupangeats = "0";
    this.spider = "0";
    this.newtrack = "0";
    this.vroong = "0";
    this.moacall = "0";
    this.barogo = "0";
    this.bbaliwa = "0";
    this.hanaro = "0";
    this.selftype = "0";
  }
},
},
};
</script>

<style scoped>
.disabled {
  opacity: 0.6;
  pointer-events: none;
  cursor: not-allowed !important;
}

.none {
display: none !important;
}

div {
/* border: red solid 2px; */
font-family: "PretendardRegular";
}

.container {
font-family: "PretendardRegular";
}

.v-text-field,
.v-btn,
.v-select {
border-radius: 0 !important;
}

.v-input--selection-controls {
padding-top: 0;
}

.dialog-title {
background-color: #01c9ff;
color: #ffffff;
}

.insert-btn,
.insert-btn-add,
.insert-addr-btn,
.insert-code-btn,
.insert-check-btn {
cursor: pointer;
}

.clearfix:before,
.clearfix:after {
display: block;
content: "";
line-height: 0;
}

.clearfix:after {
clear: both;
}

.clearfix {
zoom: 1;
}

.loading-message {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
  font-size: 18px;
  font-weight: bold;
  padding: 20px;
  z-index: 9999;
}

.input-text {
display: block;
width: 80%;
overflow: hidden;
white-space: nowrap;
text-overflow: ellipsis;
word-break: break-all;
}

/*
##Device = Desktops
##Screen = 1281px to higher resolution desktops
##Device = 데스크탑
##Screen = 1281px 이상 해상도 데스크탑
*/
.insert-store-logo-img {
/* 원하는 가로 크기 */
height: 99px;
width: 324px;            /* 가로 비율 자동 */
/* 원하는 세로 크기 */
object-fit: contain;
/* 이미지 비율 유지하면서 축소/확대 */
border: 1px solid #b2b2b2;
/* 테두리 색상 및 두께 */
border-radius: 8px;
/* 모서리 둥글게 */
padding: 2px;
/* 테두리와 이미지 간 간격 optional */
}

.insert-logo-contents{
margin-bottom: 10px;
}


@media (min-width: 1281px) {
.container {
width: 1170px !important;
}

.insert-title {
height: 59px;
font-family: "PretendardRegular";
font-size: 40px;
font-weight: 500;
font-stretch: normal;
font-style: normal;
line-height: 1.48;
letter-spacing: -0.8px;
text-align: left;
color: #333333;
margin-top: 50px;
margin-bottom: 50px;
}

.insert-border {
height: 1px;
background-color: #333333;
}

.insert-content {
width: 100%;
}

.insert-content-all {
margin-top: 50px;
width: 100%;
}

.insert-content-other {
margin-top: 0px;
}

.insert-content-other1 {
margin-top: 30px;
}

.insert-content-left {
width: 220px;
height: 29px;
margin: 15px 10px 15px 0;
font-family: "PretendardRegular";
font-size: 20px;
font-weight: 500;
font-stretch: normal;
font-style: normal;
line-height: 1.45;
letter-spacing: -0.4px;
text-align: left;
color: #333333;
}

.insert-content-left1 {
width: 220px;
height: 29px;
margin: 15px 10px 15px 0;
font-family: "PretendardRegular";
font-size: 20px;
font-weight: 500;
font-stretch: normal;
font-style: normal;
line-height: 1.45;
letter-spacing: -0.4px;
text-align: left;
color: #333333;
}

.insert-content-left2 {
width: 220px;
height: 29px;
margin: 15px 10px 0px 0;
font-family: "PretendardRegular";
font-size: 20px;
font-weight: 500;
font-stretch: normal;
font-style: normal;
line-height: 1.45;
letter-spacing: -0.4px;
text-align: left;
color: #333333;
}

.insert-content-left-warn {
width: 184px;
height: 29px;
margin: 5px 50px 0px 0px;
font-family: "PretendardRegular";
font-size: 20px;
font-weight: 500;
font-stretch: normal;
font-style: normal;
line-height: 1.45;
letter-spacing: -0.4px;
text-align: left;
color: #333333;
}

.insert-content-email-input {
width: 240px !important;
}

.insert-content-check-input {
width: 110px !important;
}

.insert-content-check-input1 {
width: 200px !important;
}

.insert-content-check-input2 {
width: 90px !important;
}

.insert-content-num-input {
width: 240px;
height: 40px;
margin-top: 3px;
}

.insert-content-delivery-input {
width: 240px;
height: 40px;
margin-top: 10px;
}

.insert-content::after {
display: block;
content: "";
clear: both;
}

.insert-content-left,
.insert-content-left1,
.insert-content-left2,
.insert-content-left-warn,
.insert-content-num-input,
.insert-content-delivery-input,
.insert-content-hyphen,
.insert-content-store-name-input,
.insert-btn,
.insert-btn-file,
.insert-btn-add,
.insert-content-code-input,
.insert-content-store-addr-input,
.insert-content-space,
.insert-content-space2,
.insert-content-checkbox-block,
.insert-content-rider-name-input {
float: left;
}

.insert-content-hyphen {
margin: 17px 6.5px 16px;
}

.insert-content-store-name-input {
width: 500px;
height: 40px;
}

.insert-content-store-img-input {
width: 760px;
height: 60px;
}

.insert-content-store-addr-input {
width: 760px;
height: 49px;
}

.insert-content-file-input {
float: left;
width: 760px;
height: 40px;
padding: 14px;
box-sizing: border-box;
border: 1px solid #b6b6b6;
position: relative;
transition: all 0.3s;
margin-top: 10px;
}

.insert-content-file-input:hover {
border: 1px solid rgb(90 90 90);
transition: all 0.3s;
}

.insert-content-file-input input[type="file"] {
width: 100%;
opacity: 0;
position: absolute;
top: 50%;
transform: translateY(-50%);
z-index: 9;
cursor: pointer;
}

.insert-content-file-input .input-text {
position: absolute;
top: 50%;
transform: translateY(-50%);
z-index: 9;
}

.insert-content-file-input .input-label {
display: inline-block;
background: #fff;
padding: 0 3px;
font-size: 12px;
position: absolute;
top: -10px;
left: 8px;
color: rgba(0, 0, 0, 0.6);
}

.insert-content-file-input+.insert-file-btn {
padding: 7px 0 17px;
text-align: center;
}

.insert-btn {
width: 160px;
height: 40px;
margin: 10px 0 0 20px;
padding: 14px 63px 17px;
background-color: #333333;
font-family: "PretendardRegular";
font-size: 18px;
font-weight: 500;
text-align: center;
color: #ffffff;
}

.insert-btn-file {
width: 160px;
height: 56px;
margin: 0 0 0 20px;
padding: 14px 63px 17px;
background-color: #333333;
font-family: "PretendardRegular";
font-size: 18px;
font-weight: 500;
text-align: center;
color: #ffffff;
}

.insert-check-btn {
padding: 14px 28px;
}

.insert-addr-btn {
padding: 7px 44px;
}

.insert-content-space {
margin: 17px 9px 16px;
}

.insert-content-space2 {
margin: 17px 3px 16px;
}

.insert-content-warn {
font-family: "PretendardRegular";
font-size: 14px;
font-weight: normal;
font-stretch: normal;
font-style: normal;
line-height: 1.43;
letter-spacing: -0.28px;
text-align: left;
color: #01caff;
}

.insert-btn-block {
margin-top: 50px;
}

.real-insert-btn {
float: right;
width: 288px;
height: 60px;
margin: 26px 10px 60px;
padding: 17px 16px;
background-color: #01c9ff;
font-size: 18px;
font-weight: 500;
font-stretch: normal;
font-style: normal;
line-height: 1.5;
letter-spacing: -0.36px;
text-align: center;
color: #ffffff;
text-decoration: none;
}

.real-insert-btn-back {
background-color: #e6e6e6;
color: #333333;
}

.insert-content-checkbox-block {
margin-right: 50px;
}

.insert-content-rider-name-input {
width: 155px;
margin-top: -16px;
}

.insert-content-order-checkbox {
margin-top: 0;
}

.insert-radio-group {
padding-top: 16px;
}

.insert-btn-duplicate {
padding: 7px 44px 7px;
}

.insert-btn-add {
width: 70px;
height: 40px;
margin: 10px 0 0 20px;
padding: 7px 0px 17px;
background-color: #333333;
font-family: "PretendardRegular";
font-size: 18px;
font-weight: 500;
text-align: center;
color: #ffffff;
}

.insert-content-term {
border: 1px solid #9e9e9e;
background-color: #fff;
font-size: 11px;
padding: 15px;
height: 95px;
overflow-y: scroll;
box-sizing: border-box;
text-align: justify;
width: 760px;
}

.insert-content-term p {
margin-bottom: 5px;
}

.insert-icon {
margin-bottom: 5px;
}

.insert-icon1 {
margin-bottom: 3px;
}

.insert-question-text {
display: none;
}

.radio-buttons-row {
margin: 10px 30px 0px 0px;
}

.insert-content-radio-button {
width: 800px !important;
margin-bottom: 5px;
}

.insert-content-text-field {
margin: 10px 0px 0px 0px;
}

.insert-content-warn-bottom-space {
margin-top: 7px;
}

.insert-platform-content {
height: 29px;
font-family: "PretendardRegular";
font-size: 20px;
font-weight: 500;
font-stretch: normal;
font-style: normal;
line-height: 2.9;
letter-spacing: -0.4px;
text-align: left;
color: #333333;
}

.checkbox-display {
display: flex;
align-items: flex-start;
}

.v-checkbox {
margin-top: 4px;
}


}

/*
##Device = Laptops, Desktops
##Screen = B/w 1025px to 1280px
##Device = 랩탑, 데스크탑
##Screen = 1025px에서 1280px 사이
*/

@media (min-width: 768px) and (max-width: 1280px) {
.container {
width: 586px !important;
}

.insert-title {
height: 59px;
font-family: "PretendardRegular";
font-size: 40px;
font-weight: 500;
font-stretch: normal;
font-style: normal;
line-height: 1.48;
letter-spacing: -0.8px;
text-align: center;
color: #333333;
margin-top: 50px;
margin-bottom: 50px;
}

.insert-border {
height: 1px;
background-color: #333333;
}

.insert-content {
width: 100%;
}

.insert-content-all {
margin-top: 50px;
width: 100%;
}

.insert-content-left-space {
display: none;
}

.insert-content-left {
width: 586px;
height: 29px;
margin: 5px 30px 5px 0;
font-family: "PretendardRegular";
font-size: 20px;
font-weight: 500;
font-stretch: normal;
font-style: normal;
line-height: 1.45;
letter-spacing: -0.4px;
text-align: left;
color: #333333;
}

.insert-content-left1 {
width: 586px;
height: 29px;
margin: 5px 30px 5px 0;
font-family: "PretendardRegular";
font-size: 20px;
font-weight: 500;
font-stretch: normal;
font-style: normal;
line-height: 1.45;
letter-spacing: -0.4px;
text-align: left;
color: #333333;
}

.insert-content-num-input {
width: 130px;
height: 45px;
}

.insert-content-delivery-input {
width: 150px;
height: 30px;
margin-top: 10px;
}

.insert-content::after {
display: block;
content: "";
clear: both;
}

.insert-content-left,
.insert-content-num-input,
.insert-content-delivery-input,
.insert-content-hyphen,
.insert-content-store-name-input,
.insert-btn,
.insert-btn1,
.insert-btn-add,
.insert-content-code-input,
.insert-content-store-addr-input,
.insert-content-space,
.insert-content-space2,
.insert-content-checkbox-block,
.insert-content-rider-name-input {
float: left;
}

.insert-content-hyphen {
margin: 9px 6.5px 16px;
}

.insert-content-store-name-input {
width: 586px;
height: 50px;
}

.insert-content-store-addr-input {
width: 430px;
height: 50px;
}

.insert-content-other {
margin-top: 0px;
}

.insert-content-file-input {
float: left;
width: 430px;
height: 40px;
padding: 14px;
margin-top: 13px;
box-sizing: border-box;
border: 1px solid #b6b6b6;
position: relative;
transition: all 0.3s;
}

.insert-content-file-input:hover {
border: 1px solid rgb(90 90 90);
transition: all 0.3s;
}

.insert-content-file-input input[type="file"] {
width: 100%;
opacity: 0;
position: absolute;
top: 50%;
transform: translateY(-50%);
z-index: 9;
cursor: pointer;
margin-top: 10px;
}

.insert-content-file-input .input-text {
position: absolute;
top: 50%;
transform: translateY(-50%);
z-index: 9;
}

.insert-content-file-input .input-label {
display: inline-block;
background: #fff;
padding: 0 3px;
font-size: 12px;
position: absolute;
top: -10px;
left: 8px;
color: rgba(0, 0, 0, 0.6);
}

.insert-content-file-input+.insert-file-btn {
margin-top: 13px;
padding: 7px 0 17px;
text-align: center;
}

.insert-btn {
width: 136px;
height: 40px;
margin: 0 0 0 20px;
padding: 14px 51px 17px;
background-color: #333333;
font-family: "PretendardRegular";
font-size: 18px;
font-weight: 500;
color: #ffffff;
}

.insert-check-btn {
padding: 14px 16px;
}

.insert-addr-btn {
padding: 7px 32px;
}

.insert-content-space {
margin: 17px 10px 16px;
}

.insert-content-space2 {
margin: 9px 3px 16px;
}

.insert-content-warn {
font-family: "PretendardRegular";
font-size: 14px;
font-weight: normal;
font-stretch: normal;
font-style: normal;
line-height: 1.43;
letter-spacing: -0.28px;
text-align: left;
color: #01caff;
margin-bottom: -30px;
}

.insert-btn-block {
margin-top: 50px;
}

.real-insert-btn {
float: right;
width: 288px;
height: 60px;
margin: 26px 2px 60px;
padding: 17px 16px;
background-color: #01c9ff;
font-size: 18px;
font-weight: 500;
font-stretch: normal;
font-style: normal;
line-height: 1.5;
letter-spacing: -0.36px;
text-align: center;
color: #ffffff;
text-decoration: none;
}

.real-insert-btn-back {
background-color: #e6e6e6;
color: #333333;
}

.insert-content-rider-name-input {
width: 155px;
margin-top: -16px;
margin-left: -61px;
}

.insert-content-order-checkbox {
margin-top: 0;
}

.insert-radio-group {
display: inline;
}

.insert-radio-btn {
width: 150px;
}

.insert-radio-btn-2 {
margin-bottom: 42px;
}

.insert-content-code-input,
.insert-content-store-addr-input-2,
.insert-code-btn {
margin-top: 6px;
}

.insert-btn-duplicate {
display: flex;
/* Flexbox 사용 */
justify-content: center;
/* 가로 중앙 */
align-items: center;
/* 세로 중앙 */
text-align: center;
/* 글자 중앙정렬 */
padding: 0px;
}

.insert-btn-add {
width: 70px;
height: 40px;
margin: 10px 0 0 20px;
padding: 7px 0px 17px;
background-color: #333333;
font-family: "PretendardRegular";
font-size: 18px;
font-weight: 500;
text-align: center;
color: #ffffff;
}

.insert-content-term {
border: 1px solid #e0e0e0;
background-color: #fff;
font-size: 11px;
padding: 15px;
height: 95px;
overflow-y: scroll;
box-sizing: border-box;
width: 586px;
}

.insert-content-term {
border: 1px solid #e0e0e0;
background-color: #fff;
font-size: 11px;
padding: 15px;
height: 95px;
overflow-y: scroll;
text-align: justify;
box-sizing: border-box;
width: 568px;
}

.insert-content-term p {
margin-bottom: 5px;
}

.insert-icon {
display: none;
}

.insert-icon1 {
margin-bottom: 3px;
}

.insert-question-text {
font-size: 13px;
}

.radio-buttons-row {
margin: 5px 30px 26px 0;
}

.insert-content-radio-button {
width: 600px !important;
}

.insert-content-warn-bottom-space {
margin-top: 5px;
margin-bottom: 45px;
}

.insert-content-check-input1 {
width: 200px !important;
}

.insert-content-check-input2 {
width: 90px !important;
}

.v-checkbox1 {
margin-top: 4px;
}

.insert-content-other1 {
margin-top: 35px;
}
}

/*
##Device = Tablets, Ipads (portrait),
##Screen = B/w 768px to 1024px
##Device = 태블릿, 아이패드(세로),
##Screen = 768px에서 1024px 사이
*/

/* @media (min-width: 768px) and (max-width: 1024px) {
} */

/*
##Device = Tablets, Ipads (landscape)
##Screen = B/w 768px to 1024px
##Device = 태블릿, 아이패드(가로)
##Screen = 768px에서 1024px 사이
*/

/* @media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
} */

/*
##Device = Low Resolution Tablets, Mobiles (Landscape)
##Screen = B/w 481px to 767px
##Device = 저해상도 태블릿, 모바일(가로)
##Screen = 481px에서 767px 사이
*/

@media (max-width: 767px) {
.container {
width: 324px !important;
}

.insert-title {
font-family: "PretendardRegular";
font-size: 24px;
font-weight: 500;
font-stretch: normal;
font-style: normal;
line-height: 1.5;
letter-spacing: -0.48px;
text-align: center;
color: #333333;
margin-top: 40px;
margin-bottom: 40px;
}

.insert-border {
height: 1px;
background-color: #333333;
}

.insert-content {
width: 100%;
}

.insert-content-all {
margin-top: 30px;
width: 100%;
}

.insert-content-left-space {
display: none;
}

.insert-content-left {
width: 324px;
height: 27px;
margin: 0 30px 0px 0;
font-family: "PretendardRegular";
font-size: 16px;
font-weight: 500;
font-stretch: normal;
font-style: normal;
line-height: 1.5;
letter-spacing: -0.32px;
text-align: left;
color: #333333;
}

.insert-content-left1 {
width: 324px;
height: 27px;
margin: 0 30px 0px 0;
font-family: "PretendardRegular";
font-size: 16px;
font-weight: 500;
font-stretch: normal;
font-style: normal;
line-height: 1.5;
letter-spacing: -0.32px;
text-align: left;
color: #333333;
}

.insert-content-num-input {
width: 98px;
height: 48px;
}

.insert-content-delivery-input {
width: 211px;
height: 48px;
}

.insert-content-check-input {
width: 150px;
}

.insert-content-check-input2 {
width: 80px !important;
}

.insert-content-email-input {
width: 45% !important;
}

.insert-content-email-sel {
width: 100% !important;
}

.insert-content::after {
display: block;
content: "";
clear: both;
}

.insert-content-other {
margin-top: 13px;
}

.insert-content-left,
.insert-content-num-input,
.insert-content-delivery-input,
.insert-content-hyphen,
.insert-content-store-name-input,
.insert-btn,
.insert-btn-add,
.insert-content-code-input,
.insert-content-store-addr-input,
.insert-content-space,
.insert-content-space2,
.insert-content-checkbox-block,
.insert-content-rider-name-input {
float: left;
}

.insert-content-hyphen {
margin: 9px 4px 16px;
}

.insert-content-store-name-input {
width: 324px;
height: 48px;
}

.insert-content-store-addr-input {
width: 211px;
height: 48px;
}

.insert-btn {
width: 324px;
height: 40px;
margin-top: 9px;
padding: 12px 51px 17px;
background-color: #333333;
font-family: "PretendardRegular";
font-size: 16px;
font-weight: 500;
font-stretch: normal;
font-style: normal;
line-height: 1.07;
letter-spacing: -0.28px;
text-align: center;
color: #ffffff;
}

.insert-addr-btn {
padding: 9px 20px;
width: 102px;
margin: 0 0 0 10px;
height: 40px;
/* padding: 19px 34px 17px; */
}

.insert-content-space {
display: none;
}

.insert-content-warn {
font-family: "PretendardRegular";
font-size: 14px;
font-weight: normal;
font-stretch: normal;
font-style: normal;
line-height: 1.43;
letter-spacing: -0.28px;
text-align: left;
color: #01caff;
margin-bottom: -12px;
margin-top: 15px;
}

.insert-btn-add {
width: 102px;
height: 40px;
margin: 0 0 0 10px;
padding: 7px 0px 17px;
background-color: #333333;
font-family: "PretendardRegular";
font-size: 18px;
font-weight: 500;
text-align: center;
color: #ffffff;
}

.insert-btn-block {
margin-top: 70px;
}

.real-insert-btn {
float: right;
width: 157px;
height: 60px;
margin: 26px 2px 60px;
padding: 17px 16px;
background-color: #01c9ff;
font-size: 18px;
font-weight: 500;
font-stretch: normal;
font-style: normal;
line-height: 1.5;
letter-spacing: -0.36px;
text-align: center;
color: #ffffff;
text-decoration: none;
}

.real-insert-btn-back {
background-color: #e6e6e6;
color: #333333;
}

.insert-content-rider-name-input {
width: 155px;
height: 48px;
margin-top: -16px;
margin-left: -61px;
}

.insert-content-order-checkbox {
margin-top: 0;
}

.insert-radio-group {
display: inline;
}

.insert-radio-btn {
width: 150px;
}

.insert-radio-btn-2 {
margin-bottom: 30px;
}

.insert-content-code-input {
margin-top: 10px;
width: 211px;
}

.insert-code-btn {
width: 102px;
margin: 11px 0 0 11px;
height: 55px;
padding: 19px 34px 17px;
}

.insert-content-store-addr-input-2 {
width: 324px;
margin-top: 10px;
}

.insert-content-store-img-input {
width: 324px;
height: 55px;
margin-top: 10px;
}

.insert-radio-btn-1 {
margin-bottom: 7px;
}

.insert-content-left-use {
margin-top: -28px;
}

.insert-content-left-imp {
margin-top: 8px;
}

.insert-content-select-list {
width: 324px;
height: 55px;
}

.insert-content-select-list-2 {
margin-top: 13px;
}

.insert-content-term {
border: 1px solid #e0e0e0;
background-color: #fff;
font-size: 11px;
padding: 15px;
height: 95px;
overflow-y: scroll;
box-sizing: border-box;
width: 760px;
}

.insert-content-term {
border: 1px solid #e0e0e0;
background-color: #fff;
font-size: 11px;
padding: 15px;
height: 95px;
overflow-y: scroll;
text-align: justify;
box-sizing: border-box;
width: 324px;
}

.insert-content-term p {
margin-bottom: 5px;
}

.insert-content-file-input {
float: left;
width: 211px;
height: 40px;
padding: 14px;
box-sizing: border-box;
border: 1px solid #b6b6b6;
position: relative;
transition: all 0.3s;
margin-top: 9px;
}

.insert-content-file-input:hover {
border: 1px solid rgb(90 90 90);
transition: all 0.3s;
}

.insert-content-file-input input[type="file"] {
width: 100%;
opacity: 0;
position: absolute;
top: 50%;
transform: translateY(-50%);
z-index: 9;
cursor: pointer;
}

.insert-content-file-input .input-text {
position: absolute;
top: 50%;
transform: translateY(-50%);
font-size: 13px;
color: rgba(0, 0, 0, 0.87);
z-index: 9;
}

.insert-content-file-input .input-label {
display: inline-block;
background: #fff;
padding: 0 3px;
font-size: 12px;
position: absolute;
top: -7px;
left: 8px;
color: rgba(0, 0, 0, 0.6);
}

.insert-content-file-input+.insert-file-btn {
float: left;
width: 102px;
margin-left: 10px;
padding: 12px 0;
text-align: center;
}

.insert-content-space2 {
width: 5%;
margin: 7px 8px;
}

.insert-content-email-sel {
margin: 10px 0;
}

.insert-icon {
display: none;
}

.insert-icon1 {
margin-bottom: 2px;
}

.insert-question-text {
font-size: 13px;
}

.radio-buttons-row {
margin: 0px 30px 26px 0;
}

.insert-content-radio-button {
width: 400px !important;
}

.insert-content-check-input1 {
width: 200px !important;
}

.insert-content-warn-bottom-space {
margin-top: -12px;
margin-bottom: 30px;
}

.insert-content-other1 {
margin-top: 30px;
}

.checkbox-display {
display: flex;
align-items: flex-start;
}

.checkbox-display1 {
display: flex;
align-items: flex-start;
}

.checkbox-display2 {
height: 33px;
}

.v-checkbox {
margin-top: 4px;
}

.v-checkbox1 {
margin-top: 4px;
}

.v-checkbox2 {
margin-top: 4px;
}

.insert-btn-duplicate {
margin-top: 0px;
}

.insert-content-text-field {
margin: 0px 0px 0px 0px;
}
}

/*
##Device = Most of the Smartphones Mobiles (Portrait)
##Screen = B/w 320px to 479px
##Device = 대부분의 스마트폰 모바일 기기(세로)
##Screen = 320px에서 479px 사이
*/

/* @media (min-width: 320px) and (max-width: 480px) {
} */
</style>